import { Component } from '@angular/core';
import { Config } from '../environments/environment';
import {ToolbarService} from "./shared/common/ToolbarEventService";
import { NavigationService } from "./shared/common/NavigationEventService"
import {BulkOperationsService} from "./shared/common/BulkOperationsService";
import {PaginationService} from "./shared/common/PaginationService";
import {NotificationService} from "./shared/common/NotificationService";
import {Authorization} from "./shared/authorization/authorization.component";
import {UsersService} from "././communication/api/users.service";
import {Title} from "@angular/platform-browser";
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'sd-app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.css'],
    providers: [
        UsersService,
        NavigationService,
        ToolbarService,
        PaginationService,
        Authorization,
        NotificationService,
        TranslateService,
        BulkOperationsService
    ],
    standalone: false
})
export class AppComponent {

  favIcon: HTMLLinkElement = document.querySelector('#appIcon');

  constructor(
    private authorization: Authorization,
    private navigationService: NavigationService,
    private toolbarService: ToolbarService,
    private paginationService: PaginationService,
    private bulkOperationsService: BulkOperationsService,
    private notificationService:NotificationService,
    private translate: TranslateService,
    private titleService: Title) {

    translate.addLangs(['en', 'tr']);
    const browserLang = translate.getBrowserLang();
    let account:any = localStorage.getItem("account");
    let accountLanguage = JSON.parse(account).language;
    let mainLanguage = accountLanguage != null ? accountLanguage : (browserLang.match(/en|tr/) ? browserLang : Config.UI_LOCALE.toLowerCase());
    translate.use(mainLanguage);
    console.log(mainLanguage)

    console.log('Environment config', Config);
    this.titleService.setTitle(Config.TITLE);
    if(Config.production){
      this.favIcon.href = "../assets/favicon/favicon-PROD.ico";
    } else {
      this.favIcon.href = "../assets/favicon/favicon-DEV.ico";
    }
  }

}
